import React, { useContext } from 'react';
import classNames from 'classnames';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';
import FaqProvider from './providers/Faq';
import PageContent from './components/PageContent';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';

import './Faq.styles.scss';

type FaqProps = {
  className?: string;
};

const Faq: React.FC<FaqProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  const {
    dataRoom: { name },
  } = useContext(DataRoomContext);

  const classes = classNames('faq', className);

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('faqHeading')} - ${name}`} />
      <FaqProvider>
        <PageContent />
      </FaqProvider>
    </div>
  );
};

export default Faq;
